import React from 'react';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { PageHero } from '../PageHero/PageHero';
import heroStyles from '../PageHero/PageHero.module.scss';
import styles from './ErrorView.module.scss';

type ErrorViewProps = {
  title: string;
  subtitle: string;
  ctaText?: string;
  ctaUrl?: string;
  onCtaClick?: (url: string) => void;
};

export function ErrorView({
  title,
  subtitle,
  ctaText,
  ctaUrl,
  onCtaClick,
}: ErrorViewProps) {
  return (
    <div className={styles.page}>
      <PageHero
        title={title}
        subtitle={subtitle}
        className={`${styles.hero} ${heroStyles.errorGlow}`}
        contentClassName={styles.contentGap}
      >
        {ctaText && ctaUrl && (
          <ButtonPrimary
            onClick={() => {
              if (onCtaClick) {
                onCtaClick(ctaUrl);
              } else {
                window.location.href = ctaUrl;
              }
            }}
          >
            {ctaText}
          </ButtonPrimary>
        )}
      </PageHero>
    </div>
  );
}
